export default __webpack_public_path__ + "static/media/zip.bca96f83.svg";